export { AngularEpubViewerModule } from './angularEpubViewer.module';
export { AngularEpubViewerComponent } from './angularEpubViewer.component';
export { EpubMetadata, EpubLocation, EpubChapter, EpubPage, EpubSearchResult, EpubError } from './angularEpubViewer.models';